import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {ResponseModel} from '@/libs/Api';
import {IssuesDataService} from '@/libs/issues/issues-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const issuesStore = registerCrudStore<ResponseModel, ResponseModel>(BusinessModule.Issue, new IssuesDataService());
